export default __webpack_public_path__ + "static/media/puzzler.a4fc88de.jpg";